export default __webpack_public_path__ + "static/media/recorte_18.e61507d5.JPG";